import { saveAs } from 'file-saver'

export default {
  data() {
    return {
      loading: false,
      action: '',
    }
  },
  methods: {
    downloadFile(uri, name, postData, type) {
      this.loading = true
      return this.$api(uri)
        .post(postData, { responseType: type })
        .then(this.successCallback(name, type))
        .catch((response) => {
          this.showMessage = true
          this.messageErreur = response.message
        })
        .finally(() => {
          this.loading = false
        })
    },

    successCallback(name, type) {
      return (response) => {
        this.messageErreur = ''
        var blob
        if (type === 'arraybuffer') {
          blob = new Blob([response.data]) //, { type: type }
        } else {
          blob = new Blob(['\ufeff', response.data], { type })
        }
        saveAs(blob, name)
      }
    },
  },
}
